// src/hooks/useScrollAnimation.js
import { useEffect, useRef, useState } from 'react';

const useScrollAnimation = (threshold = 0.1) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const node = ref.current; // ref.current를 변수에 복사
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // 한 번 나타나면 observer 해제 (재실행 방지)
          observer.unobserve(entry.target);
        }
      },
      {
        threshold,
        rootMargin: '0px 0px -50px 0px' // 100px 일찍 트리거
      }
    );

    if (node) {
      observer.observe(node);
    }

    return () => {
      // cleanup 함수에서 복사된 변수 사용
      if (node) {
        observer.unobserve(node);
      }
    };
  }, [threshold]);

  return [ref, isVisible];
};

export default useScrollAnimation;
